import type { Mission } from '../missions.ts'

export const usbp: Mission = {
  id: "usbp",
  name: "U.S. Border Patrol",
  short: "USBP",
  call: "Border",
  kind: "subagency",
  parent: "cbp",
  url: "https://www.cbp.gov/border-security/along-us-borders",
  established: 1924,
  palette: {
    primary: "#00703c",
    secondary: "#002d6a",
    accent: "#fdbc30",
  },
  colorSource: {
    kind: "flag",
    url: "https://commons.wikimedia.org/wiki/File:Flag_of_the_United_States_Border_Patrol.svg",
  },
  motif: "mountain",
  mission: {
    text: "While the Border Patrol has changed dramatically since its inception in 1924, its primary mission remains unchanged: to detect and prevent the illegal entry of individuals into the United States.",
    url: "https://www.cbp.gov/border-security/along-us-borders/overview",
  },
  fact: {
    text: "The U.S. Border Patrol was officially established on May 28, 1924, with an initial force of 450 patrol inspectors.",
    url: "https://www.cbp.gov/border-security/along-us-borders/strategy",
  },
  seal: {
    file: "public/seals/usbp.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Border_Patrol.svg",
  },
  identifier: {
    about: "https://www.cbp.gov/about",
    accessibility: "https://www.cbp.gov/site-policy-notices/accessibility",
    foia: "https://www.cbp.gov/site-policy-notices/foia",
    noFear: "https://www.cbp.gov/about/eeo/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.cbp.gov/document/publications/cbp-strategy-2021-2026",
    privacy: "https://www.cbp.gov/site-policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/usbp-campo-border-wall.jpg",
        small: "/media/usbp-campo-border-wall-sm.jpg",
        alt: "A white and green U.S. Border Patrol vehicle parked on a dirt patrol road beside the border wall, with mountains and a construction crew in the distance.",
        title: "U.S. Border Patrol vehicle near Tecate, California, June 26, 2026",
        creator: "Jeff Underwood, CBP Photography, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Border_Patrol_Agent_Works_the_Campo_Area_of_Responsibility_(55398212298).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usbp-atv-patrol.jpg",
        small: "/media/usbp-atv-patrol-sm.jpg",
        alt: "Four helmeted Border Patrol agents in green uniforms lined up on all-terrain vehicles on a gravel road in South Texas.",
        title: "Border Patrol agents on all-terrain vehicles, South Texas, September 23, 2013",
        creator: "Donna Burton, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Border_Patrol_Agent_Patrols_South_Texas_Border_on_an_All_Terrain_Vehicle_(ATV)_(11933964933).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
